<template>
  <Modal
    :config="modalConfig"
    @cancel="onCancel"
  >
    <template slot="modalContent">
      <v-card elevation="0">
        <v-card-text class="pa-0">
          <p
            class="px-2 text-body-1"
            v-text="$t('openAccountUdf.enterAdditionalDetails')"
          />
          <UdfFormBuilder
            ref="udfFormBuilder"
            :value="value"
            :form-config="`OfferUdfForm-${$i18n.locale}`"
            @input="$emit('input', $event)"
            @form-validity-change="isFormValid = $event"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            outlined
            rounded
            :color="primaryColor"
            class="text-capitalize px-4 py-2"
            data-qa="open-savings-udf-cancel"
            @click="onCancel"
          >
            {{ $t('common.cancelButton_text') }}
          </v-btn>
          <v-btn
            rounded
            :color="primaryColor"
            :dark="isFormValid"
            :disabled="!isFormValid"
            class="text-capitalize px-4 py-2"
            data-qa="open-savings-udf-confirm"
            @click="onContinue"
          >
            {{ $t('openSavingsAcc.btn.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </Modal>
</template>

<script>
import UdfFormBuilder from '../../components/common/UdfFormBuilder.vue'

export default {
  name: 'OfferUdfForm',
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    UdfFormBuilder
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      modalConfig: {
        title: this.$t('openAccountUdf.additionalDetails'),
        persistent: true,
        enabled: true,
        close: true,
        width: 600
      },
      isFormValid: false
    }
  },
  watch: {
    show (newVal) {
      if (newVal) {
        this.modalConfig.enabled = this.show
        this.resetForm()
      }
    }
  },
  created () {
    this.modalConfig.enabled = this.show
  },
  methods: {
    resetForm () {
      this.$emit('input', null)
    },
    onCancel () {
      this.modalConfig.enabled = false
      this.$emit('input', null)
      this.$emit('cancel')
      this.$nextTick(() => {
        if (this.$refs.udfFormBuilder) {
          this.$refs.udfFormBuilder.resetValidation()
        }
      })
    },
    onContinue () {
      this.modalConfig.enabled = false
      this.$emit('continue', this.value)
    }
  }
}
</script>
